import { render, staticRenderFns } from "./TrainingOrderDetail.vue?vue&type=template&id=28c20520&scoped=true&"
import script from "./TrainingOrderDetail.vue?vue&type=script&lang=js&"
export * from "./TrainingOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./TrainingOrderDetail.vue?vue&type=style&index=0&id=28c20520&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c20520",
  null
  
)

export default component.exports